import React from 'react';
import '../svg.css';


const F_A_Enterprise = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="Logo"><rect id="frame" className="f_a_enterprise-1" width="36" height="36" rx="10" /></g><g className="f_a_enterprise-2"><path className="f_a_enterprise-3" d="M26.8,9.48h0a.29.29,0,0,0-.29-.27H9.5a.31.31,0,0,0-.3.3h0v6.14h0a.28.28,0,0,0,.21.28h0l.06,0H20.05a.29.29,0,0,1,.3.29V26.51a.29.29,0,0,0,.29.29h5.87a.29.29,0,0,0,.29-.29v-17h0Z" /></g><path className="f_a_enterprise-3" d="M18.88,17.12H9.49a.29.29,0,0,0-.29.28v9.12a.29.29,0,0,0,.29.28h9.39a.28.28,0,0,0,.28-.28V17.4A.28.28,0,0,0,18.88,17.12Z" /></svg>);
};

export default F_A_Enterprise;
